import type {
	Map as MapboxMap,
	CircleLayerSpecification,
	SymbolLayerSpecification,
	FilterSpecification,
} from "mapbox-gl";
import { MapBoxLayer } from "@/components/Map/stores/MapBoxLayer";

const MARKERS_SOURCE_ID = "markers-source";
const BADGE_ID = "missing-connectivity-badge";
const BADGE_TEXT_ID = "missing-connectivity-badge-text";
const AMBER = "#f59e0b";
const BADGE_OFFSET: [number, number] = [4, -8];

const matchIds = (ids: string[]): FilterSpecification =>
	["all", ["!", ["has", "point_count"]], ["in", ["get", "id"], ["literal", ids]]] as FilterSpecification;

const badgeSpec: CircleLayerSpecification = {
	id: BADGE_ID,
	type: "circle",
	source: MARKERS_SOURCE_ID,
	filter: matchIds([]),
	layout: { visibility: "none" },
	paint: {
		"circle-radius": 5,
		"circle-color": AMBER,
		"circle-translate": BADGE_OFFSET,
	},
};

const badgeTextSpec: SymbolLayerSpecification = {
	id: BADGE_TEXT_ID,
	type: "symbol",
	source: MARKERS_SOURCE_ID,
	filter: matchIds([]),
	layout: {
		"text-field": "!",
		"text-size": 9,
		"text-allow-overlap": true,
		"text-ignore-placement": true,
		visibility: "none",
	},
	paint: {
		"text-color": "#ffffff",
		"text-translate": BADGE_OFFSET,
	},
};

export class MissingConnectivityLayers {
	private badge = new MapBoxLayer({ id: BADGE_ID, spec: badgeSpec });
	private badgeText = new MapBoxLayer({ id: BADGE_TEXT_ID, spec: badgeTextSpec });

	attach = (map: MapboxMap) => {
		this.badge.attach(map);
		this.badgeText.attach(map);
	};

	setVisible = (visible: boolean) => {
		this.badge.setVisibility(visible);
		this.badgeText.setVisibility(visible);
	};

	setMissingIds = (ids: string[]) => {
		this.badge.setFilter(matchIds(ids));
		this.badgeText.setFilter(matchIds(ids));
	};
}
